(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customers-slider"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
  $('.costomer-slider').owlCarousel({
     stagePadding: 250,
    loop:true,
     autoplay:true,
    margin:30,
    nav:true,
    responsive:{
        0:{
            items:1,
           stagePadding: 15
        },
        600:{
            items:2,
           stagePadding: 30
        },
        1000:{
            items:2,
           stagePadding: 150
        },
         1400:{
            items:3
        }
    }
})
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyclekitt-testimonial-slider"] && !window.DesignMode) return;
  try {
    
       document.addEventListener( 'DOMContentLoaded', function() {
    var testimonialsSlider = new Splide( '.rtnu-testimonials-slider', {
    type: 'slide',
    perPage: 3, // This will display 3 slides per page
    perMove: 1,
    arrows: true,
    pagination: false,
    gap: '24px',
    trimSpace: false,
    speed: 600,
    updateOnMove: true,
      breakpoints: {
        768: {
       perPage: 1, // Adjust to show only 1 slide for mobile devices
        arrows: false,
        pagination: true,
        autoHeight: false
        },
      },
    } );

    function classifySlides(newIndex) {
      var slides = document.querySelectorAll('.rtnu-testimonials-slider .splide__slide');

      // Remove the 'is-active' class from all slides
      slides.forEach(function (slide) {
        slide.classList.remove('is-active');
      });

      // Add the 'is-active' class to the new slide
      slides[newIndex].classList.add('is-active');

      slides.forEach(function (slide, index) {
        if (index < newIndex) {
          slide.classList.add('passed');
          slide.classList.remove('upcoming');
        } else if (index > newIndex) {
          slide.classList.add('upcoming');
          slide.classList.remove('passed');
        } else {
          slide.classList.remove('passed');
          slide.classList.remove('upcoming');
        }
      });
    }

    testimonialsSlider.on('move', function (newIndex) {
      classifySlides(newIndex);
    });

    testimonialsSlider.on('ready', function () {
      classifySlides(testimonialsSlider.index);

      // Add a click event listener to each slide
      var slides = document.querySelectorAll('.rtnu-testimonials-slider .splide__slide');
      slides.forEach(function (slide, index) {
        slide.addEventListener('click', function () {
          testimonialsSlider.go(index);
        });
      });
    });

    testimonialsSlider.mount();
  } );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fount-pro-feature"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
$(".close-btn").click(function(){
  $(".tab-pane").removeClass("show");
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-annoucment"] && !window.DesignMode) return;
  try {
    
   $(document).ready(function () {
    var element = $('.sticky');
    var visibilityThreshold = 700; // The scroll position at which the element becomes visible

    // Initially hide the element
    element.css({
        visibility: 'hidden',
        width: '100%',
        padding: '20px 0px',
        zIndex: '50'
    });

    $(window).scroll(function () {
        var scrollPosition = $(window).scrollTop();

        if (scrollPosition >= visibilityThreshold) {
            element.css({
                visibility: 'visible',
            
                zIndex: '50'
            });
        } else {
            element.css({
                visibility: 'hidden',
                width: '100%',
                padding: '20px 0px',
                zIndex: '50'
            });
        }
    });
});

jQuery('.page-link').click(function (e) {
    e.preventDefault();
    var menu_height = jQuery('header').outerHeight();
    var href = $(this).attr('href');
    setTimeout(function () {
        $('html,body').animate({ scrollTop: $(href).offset().top - menu_height });
    }, 700);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-section"] && !window.DesignMode) return;
  try {
    
       document.addEventListener( 'DOMContentLoaded', function() {
    var testimonialsSlider = new Splide( '.rtnu-testimonials-slider', {
      type: 'slide',
      perMove: 1,
      arrows: true,
      pagination: false,
      gap: '24px',
      trimSpace: false,
      speed: 600,
      updateOnMove: true,
      breakpoints: {
        768: {
          arrows: false,
          pagination: true,
          autoHeight: false
        },
      },
    } );

    function classifySlides(newIndex) {
      var slides = document.querySelectorAll('.rtnu-testimonials-slider .splide__slide');

      // Remove the 'is-active' class from all slides
      slides.forEach(function (slide) {
        slide.classList.remove('is-active');
      });

      // Add the 'is-active' class to the new slide
      slides[newIndex].classList.add('is-active');

      slides.forEach(function (slide, index) {
        if (index < newIndex) {
          slide.classList.add('passed');
          slide.classList.remove('upcoming');
        } else if (index > newIndex) {
          slide.classList.add('upcoming');
          slide.classList.remove('passed');
        } else {
          slide.classList.remove('passed');
          slide.classList.remove('upcoming');
        }
      });
    }

    testimonialsSlider.on('move', function (newIndex) {
      classifySlides(newIndex);
    });

    testimonialsSlider.on('ready', function () {
      classifySlides(testimonialsSlider.index);

      // Add a click event listener to each slide
      var slides = document.querySelectorAll('.rtnu-testimonials-slider .splide__slide');
      slides.forEach(function (slide, index) {
        slide.addEventListener('click', function () {
          testimonialsSlider.go(index);
        });
      });
    });

    testimonialsSlider.mount();
  } );

  } catch(e) { console.error(e); }
})();
})();
